import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5252bf00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5252bf00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252bf00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5252bf00')) {
      api.createRecord('5252bf00', component.options)
    } else {
      api.reload('5252bf00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5252bf00&scoped=true", function () {
      api.rerender('5252bf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/index.vue"
export default component.exports